/** `fmtMoney` de la maquette. */
export function fmtMoney(n: unknown): string {
  return `${(Number(n) || 0).toLocaleString('fr-FR')} F CFA`
}

/** `fmtDate` de la maquette. */
export function fmtDate(d: unknown): string {
  if (!d) return '—'
  const dt = new Date(String(d))
  if (Number.isNaN(dt.getTime())) return String(d)
  return dt.toLocaleDateString('fr-FR')
}
